module.exports = require('./lib/defaults');



//////////////////
// WEBPACK FOOTER
// ./~/json-schema-defaults/index.js
// module id = 889
// module chunks = 1